import { useEffect } from 'react'
import { wrapURLWithHandbook } from 'components/Handbook2_0/util'
import { useHistory } from 'react-router-dom'
import { useProseInstance } from 'providers/ProseInstanceProvider'

// When in a handbook, any links to docs that are in the handbook are wrapped in this logic to keep
// users in the handbook context
export const useHandbookDocNavigator = (readOnly: boolean = false) => {
  const history = useHistory()
  const { currentViewRef } = useProseInstance()

  useEffect(() => {
    if (!readOnly) return

    const clickHandler = (e: MouseEvent) => {
      if (currentViewRef.current?.dom?.contains(e.target as Node) && e.target instanceof HTMLAnchorElement) {
        const handbookURL = wrapURLWithHandbook(e.target.href)
        if (!handbookURL) return

        e.preventDefault()
        if (e.ctrlKey || e.metaKey) {
          window.open(handbookURL, '_blank')?.focus()
        } else {
          history.push(new URL(handbookURL).pathname)
        }
      }
    }

    document.addEventListener('click', clickHandler)
    return () => {
      document.removeEventListener('click', clickHandler)
    }
  }, [history, currentViewRef, readOnly])
}
